// extracted by mini-css-extract-plugin
module.exports = {"logoWrap":"index__logoWrap___12saQ","logo":"index__logo___2J1RS","ctaWrapper":"index__ctaWrapper___1hR7_","icon":"index__icon___2QZ-r","linkText":"index__linkText___2fjrJ"};